var map = {
	"./base": 111,
	"./base.vue": 111,
	"./birthday": 282,
	"./birthday.vue": 282,
	"./donate": 283,
	"./donate.vue": 283,
	"./phapa": 284,
	"./phapa.vue": 284,
	"./special-events": 285,
	"./special-events.vue": 285
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 751;


//////////////////
// WEBPACK FOOTER
// ./src/components/templates/products ^\.\/.*$
// module id = 751
// module chunks = 1